<template>
    <n-modal :show="isRobot" >
        <n-card style="width: 400px;" title="" :bordered="false" size="huge">
            It seems not human action, please try again
        </n-card>
    </n-modal>
</template>

<script>
import {NModal, NCard} from "naive-ui"
export default{
    name:"RobotCheckModal",
    props:["isRobot"],
    components:{
        NModal,
        NCard
    }
}
</script>